<template>
  <AppContent
    :label="Home.CONSULT_PROCESS"
    :subtitle="General.TEXTS.WHAT_ARE_YOU_SEARCHING"
  >
    <b-loading isFullPage :active="isLoading" />
    <CustomAdvancedSearch class="spacing-mx-10" />
    <SearchView
      class="mx-20"
      :processes="getSearchedProcessList"
      :onSelect="getDetails"
      :currentPage="currentPage"
      :setCurrentPage="setCurrentPage"
      :setOrderBy="setOrderBy"
      :perPage="perPage"
      :setPerPage="setPerPage"
    />
  </AppContent>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import AppContent from "@/layout/AppContent";
import SearchView from "@/layout/SearchView";
import CustomAdvancedSearch from "@/components/CustomAdvancedSearch";
import { General, Home } from "@/utils/constants";
import { getFormattedFilterList } from "@/utils/filterTagsUtility";
import { processfilterData } from "@/utils/filters";

export default {
  name: "SearchProcess",
  components: {
    AppContent,
    SearchView,
    CustomAdvancedSearch
  },

  data() {
    return {
      General,
      Home,
      currentPage: 1,
      perPage: 5,
      orderBy: { key: "date", name: "Data", order: "desc" },
      search: "",
      currentFilterList: [],
      filterList: {},
      isLoading: true
    };
  },

  computed: {
    ...mapGetters({
      getSearchedProcessList: "getSearchedProcessList",
      getFilterList: "getFilterList"
    })
  },

  watch: {
    getFilterList({ search, currentFilterList }) {
      this.search = search;
      this.currentFilterList = currentFilterList;
      this.filterList = getFormattedFilterList(this.currentFilterList);
      this.setCurrentPage(1);
    }
  },

  async beforeMount() {
    const { search, currentFilterList } = this.getFilterList;
    this.search = search;
    this.currentFilterList = currentFilterList;
    this.filterList = getFormattedFilterList(this.currentFilterList);

    this.processesSearch();
  },

  methods: {
    ...mapActions({
      getCompleteProcessFileStream: "getCompleteProcessFileStream",
      searchProcessByFilter: "searchProcessByFilter"
    }),

    getDetails(process) {
      if (process.status === "Arquivado")
        return this.getCompleteProcessFileStream(process.id);

      return {
        url: `/app/processos/detalhamento/${process.id}`,
        newTab: false
      };
    },
    setCurrentPage(page) {
      this.currentPage = page;
      this.processesSearch();
    },
    setPerPage(perPage) {
      this.perPage = perPage;
      this.processesSearch();
    },
    setOrderBy(order) {
      this.orderBy = order;
      this.processesSearch();
    },
    async processesSearch() {
      this.isLoading = true;
      await this.searchProcessByFilter({
        filters: {
          search: this.search,
          ...processfilterData(this.filterList)
        },
        paginator_count: this.perPage,
        page: this.currentPage,
        order_by: { [this.orderBy.key]: this.orderBy.order }
      });
      this.isLoading = false;
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-direction: column;
  align-self: center;
  padding: 15px;
  min-height: 400px;
  background-color: white;
}

.title {
  text-align: center;
  color: #049a7c;
  font-family: Montserrat, "Open Sans", Helvetica, Arial, sans-serif;
  font-weight: 500;
}
</style>
